const selectors = {
    openBtn   : '[data-navigation-open]',
    closeBtn  : '[data-navigation-close]',
    mobileNav : '.mobile-navigation',
    menu      : '.mobile-navigation__menu',
    overlay   : '.mobile-navigation__overlay'
};

export default class MobileNavigation {
    constructor() {
        this.open       = false;
        this.$openBtn   = $(selectors.openBtn);
        this.$closeBtn  = $(selectors.closeBtn);
        this.$mobileNav = $(selectors.mobileNav);
        this.$menu      = $(selectors.menu);
        this.$overlay   = $(selectors.overlay);
    }

    openNavigationMenu() {
        this.open = true;

        $(this.$menu).addClass('is--open');
        $(this.$mobileNav).css('visibility', 'visible');

        this.$overlay.animate({
            opacity: 1
        }, 200);
    }

    closeNavigationMenu() {
        this.open = false;

        $(this.$menu).removeClass('is--open');

        this.$overlay.animate({
            opacity: 0
        }, 200, () => {
            this.$mobileNav.css('visibility', 'hidden');
        });
    }

    setListeners() {
        this.$openBtn
            .off('click', '', $.proxy(this, 'openNavigationMenu'))
            .on('click', $.proxy(this, 'openNavigationMenu'));
        this.$closeBtn
            .off('click', '', $.proxy(this, 'closeNavigationMenu'))
            .on('click', $.proxy(this, 'closeNavigationMenu'));
        this.$mobileNav
            .off('click', '', $.proxy(this, 'closeNavigationMenu'))
            .on('click', '.mobile-navigation__overlay', $.proxy(this, 'closeNavigationMenu'));
    }

    init() {
        this.setListeners();
    }
}